
import axios from "axios";
import {KI_Logo_Preset} from "@k/js/rahmentabsModules/rahmenTabsLogoReiter";



type kilogodatenstoreState = {
    presets:KI_Logo_Preset[]
}

export default {
    state: () => ({
        presets:[] as KI_Logo_Preset[],
    }),
    getters: {
        getPresets(state:kilogodatenstoreState):KI_Logo_Preset[]{return state.presets}
    },
    mutations: {
        SET_PRESETS(state:kilogodatenstoreState, presets:KI_Logo_Preset[]) {
            state.presets = presets
        }
    },
    actions: {
        LOAD_PRESETS(context) {
            axios.get("/konfigurator_php/ki_logos/loadAILogoPresets.php").then(result=>context.commit("SET_PRESETS", result.data.presets));
        }
    },
}
